import { Component, Prop, Vue } from 'vue-property-decorator';
import { applyPromoCode } from '@/helpers/PromoCodes';
import { promoCodeErrorMessage } from '@/helpers/PromoCodesHelper';
import { reportFormValidity } from '@/helpers/Validation';
import FormInput2 from '@/components/forms/FormInput2.vue';
import ValidationError from '@/errors/ValidationError';
// TODO Merge/deduplicate with <CodeModal> component.
@Component({
    name: 'PromoCodesModal',
    components: { FormInput2 },
})
export default class default_1 extends Vue {
    @Prop({ default: false })
    submitDisabled;
    minLength = 2;
    rawValue = '';
    applying = false;
    error = null;
    get value() {
        return this.rawValue.trim();
    }
    apply() {
        this.applying = true;
        this.error = null;
        reportFormValidity(this.$refs.form)
            .then(() => applyPromoCode(this.value))
            .then(() => {
            this.rawValue = '';
            this.$modals.close();
        })
            .catch((error) => {
            // Prevent showing validation message in two places
            if (error instanceof ValidationError)
                return;
            const formInput = this.$refs.input;
            this.error = promoCodeErrorMessage(this.value, error, formInput.$el.querySelector('input'));
            if (this.error === this.$t('applyPromoCodes.unknownErrorMessage')) {
                throw error;
            }
        })
            .finally(() => {
            this.applying = false;
        });
    }
}
